import { AccessGroupModel } from "./access-group.model";

export class AddOrEditAccessGroupModel extends AccessGroupModel {
    description: string;
    isRequiredValidation: boolean;
    isRefreshLastUpdate: boolean;
    isIncludeInDocuments: boolean;
    roleIds: string[];
}